import * as deepmerge from 'deepmerge';
import { AppState, initialState } from './app-state';
import { LocalStorage } from './features/storage/local-storage';

export function loadInitialState(storageClient = new LocalStorage()): AppState {
  const savedState = storageClient.getItem('appState') || '{}';
  const parsedState = JSON.parse(savedState);

  return deepmerge(initialState, parsedState);
}
